import { pluralize } from '@iheartjane/utils';
import compact from 'lodash-es/compact';
import uniqBy from 'lodash-es/uniqBy';

/* eslint-disable-next-line no-restricted-imports */
import type { StoreSpecial } from '@jane/shared/models';
import type { CrmRedemption, CrmReward } from '@jane/shared/types';

export const crmDiscountAmount = (
  price: number,
  discount: CrmReward | CrmRedemption
) => {
  if (discount.reward.type === 'percent') {
    return (price * Number(discount.reward.amount)) / 100;
  } else {
    return Number(discount.reward.amount);
  }
};

export const appliedRedemptionLabel = ({
  point_value,
  reward_name,
}: {
  point_value: number;
  reward_name: string | null;
}) => {
  const points = `(${pluralize({ noun: 'pt', number: point_value })})`;
  return reward_name ? `${reward_name} ${points}` : points;
};

export const applicableProductSpecials = (
  // Structural so both the v1 and the v3 cart satisfy it.
  cart: { products: readonly { special_id?: number | string | null }[] },
  specials: StoreSpecial[]
) => {
  return uniqBy(
    compact(
      cart.products.map((cartProduct) =>
        specials.find((s) => s.id === cartProduct.special_id)
      )
    ),
    'id'
  );
};

export const applicableCartTotalSpecial = (
  specials: readonly StoreSpecial[],
  cartSpecialId: string | number | null | undefined
) => specials.find((special) => special.id === cartSpecialId);
